<template>
    <div class='page-start'>
      <mdb-container class="col-10 pb-3" fluid>
  
        <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p1" @closeAlert="p1=false" dismiss>
          Success! Submitted QIP! Go back?
          <mdbBtn class="QuadrusButton" v-on:click="returnToView">Yes</mdbBtn>
        </mdb-alert>
        <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p2" @closeAlert="p2=false" dismiss>
            {{ this.errorMsg }}
        </mdb-alert>
        <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p4" @closeAlert="p4=false" dismiss>
					There was an error uploading the file(s). The QIP was submitted without the file(s).
				</mdb-alert>
  
        <mdb-card class="mb-3 d-flex">
          <h3 class="card-header stylish-color white-text text-center font-weight-bold text-uppercase py-4">QCR Implementation Plan for QCR {{ this.qcrNumber }} <br> {{ this.qcrTitle }}</h3>
          <mdb-card-body>
            <mdb-btn v-on:click="openQCRInNewTab">View QCR</mdb-btn>
            <br><br>
            <form @submit.prevent="" class="was-validated" novalidate>
              <h4>QCR Implementation Plan Part 1 (QIP1)</h4>
              <mdb-row>
                <mdb-col>
                  <mdb-input class="mb-3" v-model="author1" :disabled="!editing_QIP1" label="Author" placeholder="" maxlength="60" 
                  required @input="checkName(author1)"/>
                  <div v-if="editing_QIP1 && !author1" class="invalid-feedback d-block">Please Input Author</div>
                  <div v-else-if="editing_QIP1 && !validName" class="invalid-feedback d-block">Please Input a valid name</div>
                  <div v-else-if="editing_QIP1 && validName" class="valid-feedback d-block">Looks Good!</div>
                </mdb-col>
              </mdb-row>
              <br>

              <h5 class="QIP-heading">1.  Introduction</h5>
              <mdb-row>
                <mdb-col>
                  <mdb-input outline type='textarea' :rows="4" v-model="introduction" :disabled="!editing_QIP1" label="Introduction" 
                  invalid-feedback="Please Input Introduction" valid-feedback="Looks Good!" maxlength="2000" required/>
                </mdb-col>
              </mdb-row>
              <br>
              <h6 class="QIP-heading">1.1  QCR Description</h6>
              <mdb-row>
                <mdb-col>
                  <mdb-input outline type='textarea' :rows="4" v-model="description" :disabled="!editing_QIP1" label="Description" 
                  invalid-feedback="Please Input Description" valid-feedback="Looks Good!" maxlength="2000" required/>
                </mdb-col>
              </mdb-row>
              <br>

              <h5 class="QIP-heading">2.  Design Analysis</h5>
              <h6 class="QIP-heading">2.1  Recommended Design Approach</h6>
              <mdb-row>
                <mdb-col>
                  <mdb-input outline type='textarea' :rows="4" v-model="designApproach" label="Design Approach" 
                  invalid-feedback="Please Input Design Approach" valid-feedback="Looks Good!" maxlength="2000" required :disabled="!editing_QIP1"/>
                </mdb-col>
              </mdb-row>
              <br>
              <h6 class="QIP-heading">2.2  Alternate Design Approach</h6>
              <mdb-row>
                <mdb-col>
                  <mdb-input outline type='textarea' :rows="4" :disabled="!editing_QIP1" v-model="designApproach2" label="Alternate Approach"
                   maxlength="2000" invalid-feedback="Please Input Alternate Approach" valid-feedback="Looks Good!" required />
                </mdb-col>
              </mdb-row>
              <br>

              <h5 class="QIP-heading">3.  Affected Documents</h5>
              <h6 class="QIP-heading">3.1  User's Manual</h6>
              <mdb-row>
                <mdb-col class="text-align-left">
                  <mdb-row>
                    <mdb-input :disabled="!editing_QIP1" type="radio" id="radio1" name="usermanual" label="Yes" radioValue="true" v-model="userManualCheckbox"/>
                    <mdb-input :disabled="!editing_QIP1" type="radio" id="radio2" name="usermanual" label="No" radioValue="false" v-model="userManualCheckbox"/>
                  </mdb-row>
                  <mdb-input outline type='textarea' :rows="4" :disabled="!editing_QIP1" v-model="userManual" label="User's Manual" maxlength="2000"/>
                </mdb-col>
              </mdb-row>
              <br>
              <h6 class="QIP-heading">3.2  Requirements Documentation</h6>
              <mdb-row>
                <mdb-col class="text-align-left">
                  <mdb-row>
                    <mdb-input :disabled="!editing_QIP1" type="radio" id="radio3" name="reqDocuments" label="Yes" radioValue="true" v-model="requirementsCheckbox"/>
                    <mdb-input :disabled="!editing_QIP1" type="radio" id="radio4" name="reqDocuments" label="No" radioValue="false" v-model="requirementsCheckbox"/>
                  </mdb-row>
                  <mdb-input outline type='textarea' :rows="4" :disabled="!editing_QIP1" v-model="requirements" label="Requirements" maxlength="2000" />
                </mdb-col>
              </mdb-row>
              <br>
              <h6 class="QIP-heading">3.3  Design Documentation</h6>
              <mdb-row>
                <mdb-col class="text-align-left">
                  <mdb-row>
                    <mdb-input :disabled="!editing_QIP1" type="radio" id="radio5" name="designDocuments" label="Yes" radioValue="true" v-model="designDocCheckbox"/>
                    <mdb-input :disabled="!editing_QIP1" type="radio" id="radio6" name="designDocuments" label="No" radioValue="false" v-model="designDocCheckbox"/>
                  </mdb-row>
                  <mdb-input outline type='textarea' :rows="4" :disabled="!editing_QIP1" v-model="designDoc" label="Design" maxlength="2000"/>
                </mdb-col>
              </mdb-row>
              <br>
              <h6 class="QIP-heading">3.4  Software Develpoment Plan</h6>
              <mdb-row>
                <mdb-col class="text-align-left">
                  <mdb-row>
                    <mdb-input :disabled="!editing_QIP1" type="radio" id="radio7" name="devPlanDocuments" label="Yes" radioValue="true" v-model="developmentPlanCheckbox"/>
                    <mdb-input :disabled="!editing_QIP1" type="radio" id="radio8" name="devPlanDocuments" label="No" radioValue="false" v-model="developmentPlanCheckbox"/>
                  </mdb-row>
                  <mdb-input outline type='textarea' :rows="4" :disabled="!editing_QIP1" v-model="developmentPlan" label="Development" maxlength="2000"/>
                </mdb-col>
              </mdb-row>
              <br>
              <h6 class="QIP-heading">3.5  Software Test Plan</h6>
              <mdb-row>
                <mdb-col class="text-align-left">
                  <mdb-row>
                    <mdb-input :disabled="!editing_QIP1" type="radio" id="radio9" name="testPlanDocuments" label="Yes" radioValue="true" v-model="testPlanCheckbox"/>
                    <mdb-input :disabled="!editing_QIP1" type="radio" id="radio10" name="testPlanDocuments" label="No" radioValue="false" v-model="testPlanCheckbox"/>
                  </mdb-row>
                  <mdb-input outline type='textarea' :rows="4" :disabled="!editing_QIP1" v-model="testPlan" label="Test Plan" maxlength="2000"/>
                </mdb-col>
              </mdb-row>
              <br>
              <h6 class="QIP-heading">3.6  Formal Qualification Test Procedure</h6>
              <mdb-row>
                <mdb-col class="text-align-left">
                  <mdb-row>
                    <mdb-input :disabled="!editing_QIP1" type="radio" id="radio11" name="fqtDocuments" label="Yes" radioValue="true" v-model="fqtProcedureCheckbox"/>
                    <mdb-input :disabled="!editing_QIP1" type="radio" id="radio12" name="fqtDocuments" label="No" radioValue="false" v-model="fqtProcedureCheckbox"/>
                  </mdb-row>
                  <mdb-input outline type='textarea' :rows="4" :disabled="!editing_QIP1" v-model="fqtProcedure" label="FQT" maxlength="2000"/>
                </mdb-col>
              </mdb-row>
              <br>
              <h6 class="QIP-heading">3.7  Software Test Report</h6>
              <mdb-row>
                <mdb-col class="text-align-left">
                  <mdb-row>
                    <mdb-input :disabled="!editing_QIP1" type="radio" id="radio13" name="testReportDocuments" label="Yes" radioValue="true" v-model="testReportCheckbox"/>
                    <mdb-input :disabled="!editing_QIP1" type="radio" id="radio14" name="testReportDocuments" label="No" radioValue="false" v-model="testReportCheckbox"/>
                  </mdb-row>
                  <mdb-input outline type='textarea' :rows="4" :disabled="!editing_QIP1" v-model="testReport" label="Test Report" maxlength="2000"/>
                </mdb-col>
              </mdb-row>
              <br>
              <h6 class="QIP-heading">3.8  Process Documentation</h6>
              <mdb-row>
                <mdb-col class="text-align-left">
                  <mdb-row>
                    <mdb-input :disabled="!editing_QIP1" type="radio" id="radio15" name="processDocuments" label="Yes" radioValue="true" v-model="processDocCheckbox"/>
                    <mdb-input :disabled="!editing_QIP1" type="radio" id="radio16" name="processDocuments" label="No" radioValue="false" v-model="processDocCheckbox"/>
                  </mdb-row>
                  <mdb-input outline type='textarea' :rows="4" :disabled="!editing_QIP1" v-model="processDoc" label="Process Documentation" maxlength="2000"/>
                </mdb-col>
              </mdb-row>
              <br>
              <h6 class="QIP-heading">3.9  Other Documentation</h6>
              <mdb-row>
                <mdb-col class="text-align-left">
                  <mdb-row>
                    <mdb-input :disabled="!editing_QIP1" type="radio" id="radio17" name="otherDocuments" label="Yes" radioValue="true" v-model="otherDocCheckbox"/>
                    <mdb-input :disabled="!editing_QIP1" type="radio" id="radio18" name="otherDocuments" label="No" radioValue="false" v-model="otherDocCheckbox"/>
                  </mdb-row>
                  <mdb-input outline type='textarea' :rows="4" :disabled="!editing_QIP1" v-model="otherDoc" label="Other" maxlength="2000"/>
                </mdb-col>
              </mdb-row>
              <br>
              
              <h5 class="QIP-heading">4.  Required Non-Labor Resources</h5>
              <mdb-row>
                <mdb-col>
                  <mdb-input outline type='textarea' :rows="4" :disabled="!editing_QIP1" v-model="resources" label="Resources" maxlength="2000" 
                  invalid-feedback="Please Input Resources" valid-feedback="Looks Good!" required/>
                </mdb-col>
              </mdb-row>
              <br>
              <h5 class="QIP-heading">5.  Required Travel</h5>
              <mdb-row>
                <mdb-col>
                  <mdb-input outline type='textarea' :rows="4" :disabled="!editing_QIP1" v-model="travel" label="Travel" maxlength="2000" 
                  invalid-feedback="Please Input Travel" valid-feedback="Looks Good!" required/>                  
                </mdb-col>
              </mdb-row>
              <br>


              <div ref="qip2" v-if="editing_QIP2 || (!editing_QIP1 && !editing_QIP2)" style="scroll-margin-top: 11vh;">
                <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p2_QIP2" @closeAlert="p2_QIP2=false" dismiss>
                    {{ this.errorMsg }}
                </mdb-alert>
                <h4>QCR Implementation Plan Part 2 (QIP2)</h4>
                <mdb-row>
                    <mdb-col>
                        <mdb-input class="mb-3" :disabled="!editing_QIP2" v-model="author2" label="Author" placeholder="" maxlength="60" 
                        :required="editing_QIP2" @input="checkName(author2)"/>
                        <div v-if="editing_QIP2 && !author2" class="invalid-feedback d-block">Please Input Author</div>
                        <div v-else-if="editing_QIP2 && !validName" class="invalid-feedback d-block">Please Input a valid name</div>
                        <div v-else-if="editing_QIP2 && validName" class="valid-feedback d-block">Looks Good!</div>
                    </mdb-col>
                </mdb-row>
                <br>

                <h5 class="QIP-heading">6. Design Details</h5>
                <h6 class="QIP-heading">6.1  Functionality Changes</h6>
                <h6 class="QIP-heading">6.1.1  Changes to Product</h6>
                <h6 class="QIP-heading">6.1.1.1  Class</h6>
                <mdb-row>
                    <mdb-col>
                        <mdb-input class="mb-3" :disabled="!editing_QIP2"  v-model="className" label="Class Name" maxlength="2000" 
                        invalid-feedback="Please Input Class" valid-feedback="Looks Good!" required/>
                    </mdb-col>
                </mdb-row>
                <br>
                <h6 class="QIP-heading">6.2  Integration</h6>
                <mdb-row>
                    <mdb-col>
                      <mdb-input outline type='textarea' :disabled="!editing_QIP2" :rows="4" v-model="integration" label="Integration"
                       maxlength="2000" invalid-feedback="Please Input Integration" valid-feedback="Looks Good!" required/>
                    </mdb-col>
                </mdb-row>
                <br>
                <h6 class="QIP-heading">6.3  Interfaces</h6>
                <h6 class="QIP-heading">6.3.1 External Interfaces</h6>
                <mdb-row>
                    <mdb-col>
                      <mdb-input outline type='textarea' :disabled="!editing_QIP2" :rows="4" v-model="externalInterfaces" 
                      label="Discuss by specific document reference, the External Standard being followed for this QCR" maxlength="2000" 
                      invalid-feedback="Please Input External Interfaces" valid-feedback="Looks Good!" required/>
                    </mdb-col>
                </mdb-row>
                <h6 class="QIP-heading">6.3.2 Internal Interfaces</h6>
                <mdb-row>
                    <mdb-col>
                      <mdb-input outline type='textarea' :disabled="!editing_QIP2" :rows="4" v-model="internalInterfaces" label="Discuss interfaces here" 
                      invalid-feedback="Please Input Internal Interfaces" valid-feedback="Looks Good!" required maxlength="2000" />
                    </mdb-col>
                </mdb-row>
                <br>
                <h6 class="QIP-heading">6.4  Reuse</h6>
                <mdb-row>
                    <mdb-col>
                      <mdb-input outline type='textarea' :disabled="!editing_QIP2" :rows="4" v-model="reuse" label="Reuse" maxlength="2000" 
                      invalid-feedback="Please Input Reuse" valid-feedback="Looks Good!" required/>
                    </mdb-col>
                </mdb-row>
                <br>

              </div>

              <div>
                <hr>
                <h4>Attachments</h4>
                  <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="wrongFile" @closeAlert="wrongFile=false" dismiss>
                    Only docx and txt files are accepted.
                  </mdb-alert>
                  <mdb-col class="text-left">
                    <mdb-btn v-if="this.previousQipDocs" v-on:click="viewDocuments">View Attached Documents</mdb-btn> 
                  </mdb-col>
                  <mdb-col v-if="editing_QIP1 || editing_QIP2">
                    <mdb-file-input ref="fileupload" :key="uploaderKey"
                      @getValue="verifyDocs" sm btn-title='UPLOAD DOCUMENT' btnColor='blue' accept=".docx,.txt"/>  
                  </mdb-col>
                <hr>
              </div>
              <br><br>
                
              <mdb-col>
                <mdb-btn class='QuadrusButton' v-on:click="returnToView" v-if="!editing_QIP1 && !editing_QIP2">Back</mdb-btn>
                <div v-if="!submitProcessing">
                  <mdb-btn class='QuadrusButton' v-on:click="submitQIP" type="submit" v-if="editing_QIP1 || editing_QIP2">Submit</mdb-btn>
                </div>
                <mdb-btn class='QuadrusButton' v-if="submitProcessing">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Processing...
                </mdb-btn>
              </mdb-col>
              <mdb-col v-if="(editing_QIP1 || editing_QIP2)">
                <mdb-btn color="danger" v-on:click="clearQIPForm">Clear</mdb-btn>
              </mdb-col>

            </form>
          </mdb-card-body>
        </mdb-card>

      <mdb-modal size="xl" :show="verifyDocPopup" @close="verifyDocPopup = false">
        <mdb-modal-header>
          <mdb-modal-title>Upload Document</mdb-modal-title>
        </mdb-modal-header>

        <mdb-modal-body>
          <p>You are replacing the current document. Do you wish to continue?</p>
        </mdb-modal-body>
        <mdb-modal-footer class="d-flex justify-content-between">
          <mdb-btn color="secondary" @click="clearDocs">Cancel</mdb-btn>
          <mdb-btn color="primary" @click="verifyDocPopup = false">Upload Document</mdb-btn>
        </mdb-modal-footer>
      </mdb-modal>

      <mdb-modal size="xl" :show="showDocsModal" @close="showDocsModal = false">
        <mdb-modal-header>
          <mdb-modal-title>Documents</mdb-modal-title>
        </mdb-modal-header>

        <mdb-modal-body>
          <div class="d-flex justify-content-between align-items-center mb-2">
            <span>{{ previousQipDocs.name }}</span>
            <mdb-btn size="sm" class="QuadrusButton" @click="downloadFile(previousQipDocs.url)">Download</mdb-btn>
          </div>
        </mdb-modal-body>
        <mdb-modal-footer class="d-flex justify-content-center">
          <mdb-btn color="secondary" @click="showDocsModal = false">Close</mdb-btn>
        </mdb-modal-footer>
      </mdb-modal>
      </mdb-container>
    </div>
  </template>
  
<style>
    .QIP-heading{text-align: left;}
</style>

  <script>
  import { mdbInput, mdbCard, mdbCardBody, mdbContainer, mdbBtn, mdbCol, mdbRow, mdbAlert, mdbFileInput, mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter } from 'mdbvue';
  import * as DatabaseLib from '@/assets/js/DatabaseLib.js';
  import * as sanitizeInput from '@/assets/js/sanitizeInput.js';
  
  export default {
      name: 'QIPForm',
      components: {
      mdbInput,
      mdbCard,
      mdbCardBody,
      mdbContainer,
      mdbBtn,
      mdbCol, 
      mdbRow,
      mdbAlert,
      mdbFileInput,
      mdbModal,
      mdbModalHeader,
      mdbModalTitle,
      mdbModalBody,
      mdbModalFooter
      },
    data() {
        return {
  
          p1: false,
          p2: false,
          p4: false,
          p2_QIP2: false,
          wrongFile: false,
          uploaderKey: 0,
          errorMsg: '',

          QIP1_stage: false,
          QIP2_stage: false,
          buildId: '',
          qcrNumber: '',
          qcrId: '',
          QIPNumber: '',
          editing_QIP1: false,
          editing_QIP2: false,
          stage: '',
          proId: '',

          author1: "",
          author2: '',
          introduction: '',
          description: '',
          designApproach: '',
          designApproach2: '',
          userManual: '',
          requirements: '',
          designDoc: '',
          developmentPlan: '',
          testPlan: '',
          fqtProcedure: '',
          testReport: '',
          processDoc: '',
          otherDoc: '',
          resources: '',
          travel: '',
          className: '',
          integration: '',
          externalInterfaces: '',
          internalInterfaces: '',
          reuse: '',
          submitProcessing: false,

          userManualCheckbox: "false",
          requirementsCheckbox: "false",
          designDocCheckbox: "false",
          developmentPlanCheckbox: "false",
          testPlanCheckbox: "false",
          fqtProcedureCheckbox: "false",
          testReportCheckbox: "false",
          processDocCheckbox: "false",
          otherDocCheckbox: "false",

          qcrTitle: '',
          qipDocs: null,
          previousQipDocs: "",
          showDocsModal: false,

          verifyDocPopup: false,
          validName: false,

          origIntro: '',
          origDesc: '',

       }
    },

    props: 
    {
      loadBuild: 
      {
        id: String,
        qcrId: Number,
        QCRnumber: Number,
        QIPNumber: Number,
        Stage: String,
        editing_QIP1: Boolean,
        editing_QIP2: Boolean,
        project: Number,
        selectedQCRs: Object,
        adding: Boolean,
        editingBuild: Boolean,
        default: null
      }
    },

    methods: {
  
      //===========================================================================================
      //	Method Name	:	loadQIPData
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Load QIP data on page load if QIP already exists
      //===========================================================================================
      loadQIPData: async function(){
        let token = this.$store.getters.getToken;
        let query = "filters[id][$in][0]=" + this.QIPNumber + "&populate[1]=qipDocs";
        let response = await DatabaseLib.getRequest('strapiDatabase','qip-forms',token,query,false);

        this.author1 = response.data.data[0].attributes.author1;
        this.author2 = response.data.data[0].attributes.author2;
        this.introduction = response.data.data[0].attributes.introduction;
        this.description = response.data.data[0].attributes.description;
        this.designApproach = response.data.data[0].attributes.designApproach;
        this.designApproach2 = response.data.data[0].attributes.designApproach2;
        this.userManual = response.data.data[0].attributes.userManual;
        this.requirements = response.data.data[0].attributes.requirements;
        this.designDoc = response.data.data[0].attributes.designDoc;
        this.developmentPlan = response.data.data[0].attributes.developmentPlan;
        this.testPlan = response.data.data[0].attributes.testPlan;
        this.fqtProcedure = response.data.data[0].attributes.fqtProcedure;
        this.testReport = response.data.data[0].attributes.testReport;
        this.processDoc = response.data.data[0].attributes.processDoc;
        this.otherDoc = response.data.data[0].attributes.otherDoc;
        this.resources = response.data.data[0].attributes.resources;
        this.travel = response.data.data[0].attributes.travel;
        this.className = response.data.data[0].attributes.className;
        this.integration = response.data.data[0].attributes.integration;
        this.externalInterfaces = response.data.data[0].attributes.externalInterfaces;
        this.internalInterfaces = response.data.data[0].attributes.internalInterfaces;
        this.reuse = response.data.data[0].attributes.reuse;
        this.userManualCheckbox = response.data.data[0].attributes.userManualCheckbox ? "true" : "false";
        this.requirementsCheckbox = response.data.data[0].attributes.requirementsCheckbox ? "true" : "false";
        this.designDocCheckbox = response.data.data[0].attributes.designDocCheckbox ? "true" : "false";
        this.developmentPlanCheckbox = response.data.data[0].attributes.developmentPlanCheckbox ? "true" : "false";
        this.testPlanCheckbox = response.data.data[0].attributes.testPlanCheckbox ? "true" : "false";
        this.fqtProcedureCheckbox =  response.data.data[0].attributes.fqtProcedureCheckbox ? "true" : "false";
        this.testReportCheckbox = response.data.data[0].attributes.testReportCheckbox ? "true" : "false";
        this.processDocCheckbox = response.data.data[0].attributes.processDocCheckbox ? "true" : "false";
        this.otherDocCheckbox = response.data.data[0].attributes.otherDocCheckbox ? "true" : "false";
        let tempDocs = response.data.data[0].attributes.qipDocs?.data || null;
        this.qip_stage = response.data.data[0].attributes.qip_stage;

        this.origIntro = response.data.data[0].attributes.introduction;
        this.origDesc = response.data.data[0].attributes.description;

        
        if(this.editing_QIP1){
          this.checkName(this.author1);
        } else if(this.editing_QIP2){
          this.checkName(this.author2);
        }

        if(tempDocs) {
          this.previousQipDocs = {id: tempDocs.id, name: tempDocs.attributes.name, url: tempDocs.attributes.url};
        }          
      },

      //===========================================================================================
      //	Method Name	:	clearQIPForm
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	clears the form
      //===========================================================================================
      clearQIPForm: function() {
        if(this.editing_QIP1){
          this.introduction = this.origIntro;
          this.description = this.origDesc;
          this.author1 = '';
          this.designApproach = '';
          this.designApproach2 = '';
          this.userManual = '';
          this.requirements = '';
          this.designDoc = '';
          this.developmentPlan = '';
          this.testPlan = '';
          this.fqtProcedure = '';
          this.testReport = '';
          this.processDoc = '';
          this.otherDoc = '';
          this.resources = '';
          this.travel = '';
          this.userManualCheckbox = "false";
          this.requirementsCheckbox = "false";
          this.designDocCheckbox = "false";
          this.developmentPlanCheckbox = "false";
          this.testPlanCheckbox = "false";
          this.fqtProcedureCheckbox = "false";
          this.testReportCheckbox = "false";
          this.processDocCheckbox = "false";
          this.otherDocCheckbox = "false";
        } else if(this.editing_QIP2){
          this.author2 = '';
          this.className = '';
          this.integration = '';
          this.externalInterfaces = '';
          this.internalInterfaces = '';
          this.reuse = '';
        }
      },

      viewDocuments: function(){
        this.showDocsModal = true;
      },

      downloadFile: async function(url) {
        url = DatabaseLib.getEndpoint('strapiDatabase').slice(0, -1) + url
        try {
          const response = await fetch(url)
          const blob = await response.blob()

          const blobUrl = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = blobUrl
          link.download = url.split('/').pop()

          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)

          window.URL.revokeObjectURL(blobUrl)
        } catch (error) {
          console.error('Download failed:', error)
        }
      },

      checkName: function(name){
        let nameRegex = new RegExp(/^[\p{L}]+(?:[ '’.-][\p{L}]+)*$/u);
        if(nameRegex.test(name)){
          this.validName = true;
        } else {
          this.validName = false;
        }
      },

      validateQIPForm: function(QIPStage){
        let isValid = false;
        let authorValid = false;
        let nameRegex = new RegExp(/^[\p{L}]+(?:[ '’.-][\p{L}]+)*$/u);
        if(QIPStage == 1){
          if(this.author1 != '' && nameRegex.test(this.author1)){
            authorValid = true;
          }
          if(authorValid && this.introduction != '' && this.description != '' && this.designApproach != '' && this.designApproach2 != ''  
          && this.resources != '' && this.travel != ''){
            isValid = true;
          } else {
            isValid = false;
          }
        } else if(QIPStage == 2){  
          if(this.author2 != '' && nameRegex.test(this.author2)){
            authorValid = true;
          }
          if(authorValid && this.author2 != '' && this.className != '' && this.integration != '' && this.externalInterfaces != '' && this.internalInterfaces != '' && this.reuse != ''){
            isValid = true;
          } else {
            isValid = false;
          }
        }

        return isValid;
      },
  
      //===========================================================================================
      //	Method Name	:	submit QIP
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Submits a QIP
      //===========================================================================================
      submitQIP: async function() {
        let token = this.$store.getters.getToken;

        //Validate data
        if(this.editing_QIP1 && !this.validateQIPForm(1)){
          this.errorMsg = "Missing required fields or Invalid inputs. Please try again!";
          this.p2 = true;
          window.scroll({top: 0, behavior: 'smooth'});
          return;
        } else if (this.editing_QIP2 && !this.validateQIPForm(2)){
          this.errorMsg = "Missing required fields or Invalid inputs. Please try again!";
          this.p2_QIP2 = true;
          this.$refs.qip2.scrollIntoView({behavior: 'smooth'})
          return;
        }
        
        this.submitProcessing = true;
  
        //sanitize data
        this.author1 = sanitizeInput(this.author1, this.$sanitize);
        this.author2 = sanitizeInput(this.author2, this.$sanitize);
        this.introduction = sanitizeInput(this.introduction, this.$sanitize);
        this.description = sanitizeInput(this.description, this.$sanitize);
        this.designApproach = sanitizeInput(this.designApproach, this.$sanitize);
        this.designApproach2 = sanitizeInput(this.designApproach2, this.$sanitize);
        this.userManual = sanitizeInput(this.userManual, this.$sanitize);
        this.designDoc = sanitizeInput(this.designDoc, this.$sanitize);
        this.requirements = sanitizeInput(this.requirements, this.$sanitize);
        this.developmentPlan = sanitizeInput(this.developmentPlan, this.$sanitize);
        this.testPlan = sanitizeInput(this.testPlan, this.$sanitize);
        this.fqtProcedure = sanitizeInput(this.fqtProcedure, this.$sanitize);
        this.testReport = sanitizeInput(this.testReport, this.$sanitize);
        this.processDoc = sanitizeInput(this.processDoc, this.$sanitize);
        this.otherDoc = sanitizeInput(this.otherDoc, this.$sanitize);
        this.resources = sanitizeInput(this.resources, this.$sanitize);
        this.travel = sanitizeInput(this.travel, this.$sanitize);
        this.className = sanitizeInput(this.className, this.$sanitize);
        this.integration = sanitizeInput(this.integration, this.$sanitize);
        this.externalInterfaces = sanitizeInput(this.externalInterfaces, this.$sanitize);
        this.internalInterfaces = sanitizeInput(this.internalInterfaces, this.$sanitize);
        this.reuse = sanitizeInput(this.reuse, this.$sanitize); 
        
        
        // ---- Upload documents (optional) ----
        let fileId = null;
        let fileInfo = null;

        if (this.qipDocs) {
          try {
            const formData = new FormData();

            formData.append(
              'files',
              this.qipDocs[0],
              `${this.author1}_${this.qipDocs[0].name}`
            );
            const response = await DatabaseLib.postRequest(
              'strapiDatabase',
              'upload',
              token,
              formData
            );

            // Strapi still returns an array, even when uploading one file
            fileInfo = response.data[0];
            fileId = response.data[0].id;
          } catch (err) {
            console.error("File upload failed, continuing without file", err);
            this.p4 = true;
          }
        }
        let data = {
          data: {
            author1: this.author1,
            author2: this.author2,
            introduction: this.introduction,
            description: this.description,
            designApproach: this.designApproach,
            designApproach2: this.designApproach2,
            userManual: this.userManual,
            requirements: this.requirements,
            designDoc: this.designDoc,
            developmentPlan: this.developmentPlan,
            testPlan: this.testPlan,
            fqtProcedure: this.fqtProcedure,
            testReport: this.testReport,
            processDoc: this.processDoc,
            otherDoc: this.otherDoc,
            resources: this.resources,
            travel: this.travel,
            className: this.className,
            integration: this.integration,
            externalInterfaces: this.externalInterfaces,
            internalInterfaces: this.internalInterfaces,
            reuse: this.reuse,
            qip_stage: this.stage == "Development" ? "QIP-2s" : this.qip_stage ? this.qip_stage : "QIP-1s",
            userManualCheckbox: this.userManualCheckbox == "true" ? true : false,
            requirementsCheckbox: this.requirementsCheckbox == "true" ? true : false,
            designDocCheckbox: this.designDocCheckbox == "true" ? true : false,
            developmentPlanCheckbox: this.developmentPlanCheckbox == "true" ? true : false,
            testPlanCheckbox: this.testPlanCheckbox == "true" ? true : false,
            fqtProcedureCheckbox: this.fqtProcedureCheckbox == "true" ? true : false,
            testReportCheckbox: this.testReportCheckbox == "true" ? true : false,
            processDocCheckbox: this.processDocCheckbox == "true" ? true : false,
            otherDocCheckbox: this.otherDocCheckbox == "true" ? true : false,
            qipDocs: fileId ? fileId : this.previousQipDocs.id, 
          }
        }
        try {
          let response = '';
            if(this.editing_QIP2){
              response = await DatabaseLib.putRequest('strapiDatabase','qip-forms',token,this.QIPNumber,data);
            } else if(this.QIPNumber){
              response = await DatabaseLib.putRequest('strapiDatabase','qip-forms',token,this.QIPNumber,data);
            } else {
              response = await DatabaseLib.postRequest('strapiDatabase','qip-forms',token,data);
            }
            let qip_id = response.data.data.id
            data = {
              data: {
                qip_form: qip_id,
              }
            }
            await DatabaseLib.putRequest('strapiDatabase','qcrs',token,this.qcrId,data);
          

            // update build stage
            if(this.buildId){
              let stage = this.stage;
              let query = "";
              let totalQIP1s = 0, totalQIP2s = 0, totalQCRs = 0;
              let reqBuild = false;
              let devBuild = false;

              query = "filters[id][$in][0]="+ this.buildId + "&populate[1]=qcrs";
              response = await DatabaseLib.getRequest('strapiDatabase','builds',token,query,false);
              
              if(response.data.data.length > 0){
                reqBuild = response.data.data[0].attributes.requirements;
                devBuild = response.data.data[0].attributes.development;

                if(response.data.data[0].attributes.qcrs.data.length > 0){
                  totalQCRs = response.data.data[0].attributes.qcrs.data.length;
                  let qcr = response.data.data[0].attributes.qcrs.data;
                  for(var i =0; i < qcr.length; i++){
                    let query2 = "filters[id][$in][0]="+ qcr[i].id + "&populate[1]=qip_form";
                    let response2 = await DatabaseLib.getRequest('strapiDatabase','qcrs',token,query2,false);
                    
                    if(response2.data.data.length > 0){
                      if(response2.data.data[0].attributes.qip_form.data != null){
                        if(response2.data.data[0].attributes.qip_form.data.attributes.qip_stage == "QIP-1s"){
                          totalQIP1s += 1;
                        }
                        if(response2.data.data[0].attributes.qip_form.data.attributes.qip_stage == "QIP-2s"){
                          totalQIP2s += 1;
                        }
                      }
                    }
                  }
                }
              }             
             
              if(totalQIP1s == totalQCRs && this.stage == "QIP-1s"){
                this.QIP1_stage = true;
                stage = "Project Planning"
              } else if(totalQIP2s == totalQCRs && this.stage == "Development"){
                this.QIP2_stage = true;
                this.QIP1_stage = true;

                if(reqBuild && devBuild && this.QIP2_stage){
                  stage = "Dry Runs";
                }
              }
 
              if(this.stage == "QIP-1s" || this.stage == "Development"){
                data = {
                  data: {
                    QIP1: this.QIP1_stage,
                    QIP2: this.QIP2_stage,
                    stage: stage
                  }
                }
                await DatabaseLib.putRequest('strapiDatabase','builds',token,this.buildId,data);
              }
            }

          this.p1 = true;
          window.scroll({top: 0, behavior: 'smooth'});
          this.submitProcessing = false;
          this.qipDocs = null;
        } catch(error) {
          if(this.editing_QIP1){
            this.errorMsg = "There was an error submitting QIP. Please try again!";
            this.p2 = true;
            window.scroll({top: 0, behavior: 'smooth'});
          }
          if(this.editing_QIP2){
            this.$refs.qip2.scrollIntoView({behavior: 'smooth'});
            this.p2_QIP2 = true;
          }
          this.submitProcessing = false;
          return;
        }
        if(fileInfo){
          this.previousQipDocs = {id: fileInfo.id, name: fileInfo.name, url: fileInfo.url};
        }
      },

      verifyDocs: function(value){
        if(value[0].type && (value[0].name.includes('.docx') || value[0].name.includes('.txt'))){
          this.qipDocs = value;
          if(this.previousQipDocs){
            this.verifyDocPopup = true; 
          }
        } else {
          // Reject the file
          this.wrongFile = true;
          this.uploaderKey++;
          return;
        }
      },
      clearDocs: function(){
        this.qipDocs = null;
        this.verifyDocPopup = false;
        const fileComponent = this.$refs.fileupload;

        if (fileComponent) {
          fileComponent.customText = ""; 
          fileComponent.files = []; 
          const nativeInput = fileComponent.$el.querySelector('input[type="file"]');
          if (nativeInput) {
            nativeInput.value = '';
          }
        }
      },
    

      //===========================================================================================
      //	Method Name	:	returnToView
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Goes back to previous page when viewing QIP
      //===========================================================================================
      returnToView: function(){
        let lastRouteName = localStorage.getItem('previousRoute');
        if(lastRouteName == 'ViewEditBuild'){
          this.$router.push({
            name: 'ViewEditBuild',
            query: {
              id: this.buildId,
              project: this.proId
            }
          })
        } else {
          this.$router.go(-1);
        }
      },

      //===========================================================================================
      //	Method Name	:	openQCRInNewTab
      //	Description:
      //	-----------------------------------------------------------------------------------------
      //	Opens QCR in new tab
      //===========================================================================================
      openQCRInNewTab: function(){
        const routeData = this.$router.resolve({
          name: 'ViewQCR',
          query: { id: this.qcrId }
        });
        window.open(routeData.href, '_blank');
      },

      loadQCR: async function(){
        let token = this.$store.getters.getToken;
        let query = "filters[QCRnumber][$eq][0]="+ this.qcrNumber + "&populate[0]=submitted_qpr";
        let qcr = await DatabaseLib.getRequest('strapiDatabase','qcrs',token,query,false);
        this.qcrTitle = qcr.data.data[0].attributes.submitted_qpr.data.attributes.title;

        if(!this.QIPNumber){
          this.introduction = "This document serves as the Implementation Plan for QCR #" + this.qcrNumber 
            + ". It is associated with QPR #" + qcr.data.data[0].attributes.submitted_qpr.data.id + ".";
          this.description = qcr.data.data[0].attributes.submitted_qpr.data.attributes.currentFunction + "\n" 
            + qcr.data.data[0].attributes.submitted_qpr.data.attributes.expectedFunction;

          this.origDesc = this.description;
          this.origIntro = this.introduction;
        }
      },

      //===========================================================================================
      //	Method Name	:	bindProps
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Loads data passed to the page
      //===========================================================================================
      bindProps: function(){
        if(this.loadBuild != null){
          this.buildId = this.loadBuild.id;
          this.qcrId = this.loadBuild.qcrId;
          this.qcrNumber = this.loadBuild.QCRnumber;
          this.QIPNumber = this.loadBuild.QIPNumber;
          this.stage = this.loadBuild.Stage;
          this.editing_QIP1 = this.loadBuild.editing_QIP1;
          this.editing_QIP2 = this.loadBuild.editing_QIP2;
          this.proId = this.loadBuild.project;

          if(this.QIPNumber){
            this.loadQIPData();
          }
          this.loadQCR();
        }
      }
    },
    mounted(){
        window.scroll({top: 0, behavior: 'smooth'});
        this.bindProps();
    }
  }
  </script>